import React from "react";

const Input = (props) =>  (
  <div className="input">
    <label htmlFor={ props.name }>
    { props.title && 
      <span>{props.title}</span>
    }
    {props.required ? (
      <input type={ props.type } min={ 0 } max={ 1000 } value={props.value} id={props.name} name={ props.name } required placeholder={ props.placeholder } pattern={ props.pattern } onChange={ (e) => props.setFunction( e.target.value ) } />
      ) : (
      <input type={ props.type } min={ 1 } max={ 1000 } value={props.value} id={props.name}  name={ props.name } placeholder={ props.placeholder } pattern={ props.pattern } onChange={ (e) => props.setFunction( e.target.value ) } onBlur={ (e) => props.setBlur( e.target.value )} disabled={ props.disabled } />
      )}
    </label>
  </div>
)

export default Input;